export enum MedicalIndicatorType {
    COMORBIDITIES = 'COMORBIDITIES',
    MEDICAMENTS = 'MEDICAMENTS'
}



